export const openCloseDialog = (dialog: HTMLDialogElement) => {
  if (dialog && dialog.open) {
    dialog.close();
  } else {
    dialog.showModal();
    dialog.dispatchEvent(new Event('dialogopened'));
  }
};
